import { Injectable } from '@angular/core';

import { Credentials, KeycloakCodes } from 'app/models';
import { StorageKey } from 'app/models/enums';

@Injectable()
export class OauthRepository {
  public setKeycloakCodes(keycloakCodes: KeycloakCodes): void {
    localStorage.setItem(StorageKey.KEYCLOAK, JSON.stringify(keycloakCodes));
  }

  public getKeycloakCodes(): KeycloakCodes {
    return JSON.parse(localStorage.getItem(StorageKey.KEYCLOAK));
  }

  public setKeycloakCsrfState(csrfState): void {
    localStorage.setItem(StorageKey.KEYCLOAK_CSRF_STATE, csrfState);
  }

  public getKeycloakCsrfState(): string {
    return localStorage.getItem(StorageKey.KEYCLOAK_CSRF_STATE);
  }

  public setCredentials(credentials: Credentials): void {
    localStorage.setItem(StorageKey.CREDENTIALS, JSON.stringify(credentials));
  }

  public getCredentials(): Credentials {
    return JSON.parse(localStorage.getItem(StorageKey.CREDENTIALS));
  }

  public deleteAuthData(): void {
    const removeableStorageKeys = [];
    for (let i = 0; i < localStorage.length; i++) {
      if (localStorage.key(i).startsWith('cbm-')) {
        removeableStorageKeys.push(localStorage.key(i));
      }
    }

    for (const removeableStorageKey of removeableStorageKeys) {
      localStorage.removeItem(removeableStorageKey);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/repositories/oauth.repository.ts